<template>
  <div class="content products-list">
    <div class="spim-loader-container" :class="{ 'is-loading': isLoading }">
      <spim-loader></spim-loader>
      <div
        v-if="products.data.length > 0"
        class="content content--products-list"
      >
        <table class="items-table">
          <thead class="items-table__thead">
            <tr class="items-table__tr">
              <th class="items-table__th">
                <div
                  @click.prevent="sortObjects()"
                  class="items-table__sort"
                  :class="{ 'is-active': orderBy == 'index' }"
                  order-by="index"
                  order="desc"
                >
                  Index
                  <icon icon="sort" icon-classes="items-table__sort-icon" />
                </div>
              </th>
              <th class="items-table__th">
                <div
                  @click.prevent="sortObjects()"
                  class="items-table__sort"
                  :class="{ 'is-active': orderBy == 'status' }"
                  order-by="status"
                  order="desc"
                >
                  Status
                  <icon icon="sort" icon-classes="items-table__sort-icon" />
                </div>
              </th>
              <th class="items-table__th">Zdjęcie</th>
              <th class="items-table__th items-table__th--expand">Nazwa</th>
              <th class="items-table__th items-table__th--nowrap">
                Alerty
              </th>
              <th class="items-table__th items-table__th--nowrap">
                Warianty
              </th>
              <th class="items-table__th">
                Status synch.
              </th>

              <th class="items-table__th">
                <div
                  @click.prevent="sortObjects()"
                  class="items-table__sort"
                  :class="{ 'is-active': orderBy == 'updated_at' }"
                  order-by="updated_at"
                  order="desc"
                >
                  Modyfikacja
                  <icon icon="sort" icon-classes="items-table__sort-icon" />
                </div>
              </th>
              <th class="items-table__th">
                Język
              </th>
              <th class="items-table__th p-0 text-right">Akcje</th>
            </tr>
          </thead>

          <tbody class="items-table__tbody">
            <!-- item -->
            <template v-for="product in products.data">
              <tr class="items-table__tr" v-bind:key="product.id">
                <td class="items-table__td">
                  <div class="form-box__mobile-element">Index</div>
                  {{ product.index ? product.index : "-" }}
                </td>

                <td class="items-table__td items-table__td--not-text">
                  <div class="form-box__mobile-element">Status</div>
                  <div
                    :class="[
                      'm-auto',
                      'items-table__status',
                      {
                        'items-table__status--active': product.status == '1',
                      },
                    ]"
                  ></div>
                </td>
                <td class="items-table__td">
                  <div class="form-box__mobile-element">Zdjecie</div>
                  <div>
                    <img
                      :src="
                        getApiPath(
                          product.main_photo ? product.main_photo.path : null
                        )
                      "
                    />
                  </div>
                </td>
                <td class="items-table__td items-table__td--expand">
                  <div class="form-box__mobile-element">Nazwa</div>
                  <router-link
                    class="items-table__link"
                    v-bind:to="{
                      name: 'productEdit',
                      params: { id: product.id, locale: product.locale },
                    }"
                    >{{ product.name }}
                  </router-link>
                </td>
                <td class="items-table__td">
                  <div class="form-box__mobile-element">Alerty</div>
                  <AlertData :product="product"></AlertData>
                </td>
                <td class="items-table__td text-center">
                  <div class="form-box__mobile-element">Warianty</div>
                  {{ product.have_variants ? product.variants.length : "nd." }}
                </td>
                <td class="items-table__td items-table__td--not-text">
                  <div class="form-box__mobile-element">
                    Status synch.
                  </div>
                  <div
                    :class="[
                      'm-auto',
                      'items-table__status',
                      'items-table__status--' + wooSyncStatus(product),
                    ]"
                  ></div>
                </td>

                <td class="items-table__td items-table__td--nowrap">
                  <div class="form-box__mobile-element">Modyfikacja</div>
                  {{ product.updated_at | prettyDate }}
                </td>

                <td class="items-table__td">
                  <div class="form-box__mobile-element"></div>
                  <ul class="lang-list">
                    <template v-for="lang in product.all_languages">
                      <li
                        v-if="!lang.id"
                        :key="lang.locale"
                        class="lang-list__item"
                      >
                        <a
                          class="lang-list__link"
                          @click.prevent="
                            editOrCreateLang(lang, 'addTranslation', product)
                          "
                        >
                          {{ lang.locale }}
                        </a>
                      </li>

                      <li
                        v-else
                        :key="lang.locale"
                        class="lang-list__item lang-list__item--exist"
                      >
                        <a
                          class="lang-list__link"
                          @click.prevent="
                            editOrCreateLang(lang, 'productEdit', product)
                          "
                        >
                          {{ lang.locale }}
                        </a>
                      </li>
                    </template>
                  </ul>
                </td>

                <td class="items-table__td pr-0">
                  <div class="form-box__buttons">
                    <router-link
                      :to="{
                        name: 'productEdit',
                        params: { id: product.id, locale: product.locale },
                      }"
                      class="button-icon button-icon--ml-10"
                      data-tooltip="Edycja produktu"
                    >
                      <icon icon="edit" icon-classes="icon--grey" />
                    </router-link>
                  </div>
                </td>
              </tr>
            </template>
            <!-- end of item -->
          </tbody>
        </table>
      </div>
      <!-- // Products list-->
      <div v-else class="content">
        Brak wyników.
      </div>
    </div>
    <!-- Pagination -->
    <pagination
      :pagination="products"
      @paginate="getProducts()"
      :offset="1"
    ></pagination>
    <!-- Pagination -->
  </div>
  <!-- // Products -->
</template>

<script>
import axios from "axios";
import Icon from "./Icon";
import Pagination from "./Pagination";
import { wooSyncStatus } from "../../helpers/statusWoo";
import { editOrCreateLang } from "../../helpers/editOrCreateLang";
import SpimLoader from "./SpimLoader.vue";
import AlertData from "./AlertData.vue";
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  data() {
    return {
      isLoading: true,
      products: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1,
        data: {},
      },
      message: "",
      order: "desc",
      orderBy: "created_at",
      filters: { only_alerts: true },
    };
  },
  components: {
    Pagination,
    Icon,
    SpimLoader,
    AlertData,
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    async getProducts() {
      this.isLoading = true;
      try {
        const config = {
          headers: {
            "content-type": "text/html",
          },
        };
        var params = {
          page: this.products.current_page,
          orderBy: this.orderBy,
          order: this.order,
          filters: this.filters,
        };

        if (this.$i18n.locale) params.locale = this.$i18n.locale;

        const response = await axios.get(
          API_BASE_URL + "/products",
          {
            params: params,
          },
          config
        );
        this.products = response.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$root.$emit("noticesBox", error.response.data);
      }
    },
    sortObjects() {
      event.target.setAttribute("order", this.order == "asc" ? "desc" : "asc");
      this.orderBy = event.target.getAttribute("order-by");
      this.order = event.target.getAttribute("order");

      this.getProducts();
    },
    editOrCreateLang,
    wooSyncStatus,
    getApiPath(path) {
      if (path) {
        return API_BASE_URL + "/" + path;
      } else return require("../../img/default.png");
    },
  },
};
</script>
